<template>
  <div class="rpx2 text-xs">
    <div v-if="!initiated">
      <p>Initiating...</p>
    </div>

    <div v-else-if="errors">
      <p class="text-red-600">Error: {{ errors }}</p>
    </div>
    <div v-else-if="!resourceLength && initiated">
      <p class="text-orange-600">Nothing  found...</p>
    </div>

    <div v-else-if="!allowToLoadMore">
      <p class="text-orange-600">Everything loaded...</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initiated: {
      type: Boolean,
      required: true
    },
    errors: {
      type: [String, Object],
    },
    resourceLength: {
      type: Number,
      required: true
    },
    allowToLoadMore: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.rpx2 {
  padding-right: 0.5rem;
}

.text-red-600 {
  color: #E53E3E;
}

.text-orange-600 {
  color: #DD6B20;
}
</style>
